// UI strings for signing in (the login screen, shell/Login.tsx) and changing the password
// (Asetukset → Tili). Finnish (default) and English side by side; en has exactly the same shape.
// Style: docs/FINNISH-STYLE.md. Error lines never say which of the two fields was wrong.
import { defineArea } from '../area';

export const loginFi = {
  title: 'Kirjaudu sisään',
  username: 'Käyttäjätunnus',
  password: 'Salasana',
  submit: 'Kirjaudu',
  submitting: 'Kirjaudutaan…',
  /** Shown above the form when this device was signed in before and the session ended. */
  ended: 'Istunto on päättynyt. Kirjaudu uudelleen, niin jatkat siitä, mihin jäit.',
  empty: 'Kirjoita käyttäjätunnus ja salasana.',
  wrong: 'Käyttäjätunnus tai salasana on väärin.',
  locked: (minutes: number): string => `Liian monta väärää yritystä. Yritä uudelleen ${minutes} minuutin kuluttua.`,
  offline: 'Kirjautuminen vaatii yhteyden. Yritä uudelleen, kun olet verkossa.',
  failed: 'Kirjautuminen ei onnistunut. Yritä hetken kuluttua uudelleen.',
  change: {
    h: 'Vaihda salasana',
    current: 'Nykyinen salasana',
    next: 'Uusi salasana',
    repeat: 'Uusi salasana uudelleen',
    rule: 'Vähintään 10 merkkiä. Pitkä lause, jonka muistat, on hyvä salasana.',
    submit: 'Vaihda salasana',
    saving: 'Vaihdetaan…',
    done: 'Salasana on vaihdettu. Muilla laitteillasi kirjaudutaan seuraavaksi uudella salasanalla.',
    mismatch: 'Uudet salasanat eivät ole samat.',
    short: 'Uuden salasanan on oltava vähintään 10 merkkiä.',
    wrongCurrent: 'Nykyinen salasana on väärin.',
    offline: 'Salasanan vaihtaminen vaatii yhteyden.',
    failed: 'Salasanan vaihtaminen ei onnistunut. Yritä hetken kuluttua uudelleen.',
    demo: 'Demotilassa salasanaa ei voi vaihtaa.',
  },
};

export const loginEn: typeof loginFi = {
  title: 'Sign in',
  username: 'Username',
  password: 'Password',
  submit: 'Sign in',
  submitting: 'Signing in…',
  ended: 'Your session has ended. Sign in again to carry on where you left off.',
  empty: 'Enter your username and password.',
  wrong: 'The username or password is wrong.',
  locked: (minutes) => `Too many wrong attempts. Try again in ${minutes} ${minutes === 1 ? 'minute' : 'minutes'}.`,
  offline: 'Signing in needs a connection. Try again when you are online.',
  failed: 'Signing in did not work. Try again in a moment.',
  change: {
    h: 'Change password',
    current: 'Current password',
    next: 'New password',
    repeat: 'New password again',
    rule: 'At least 10 characters. A long sentence you remember makes a good password.',
    submit: 'Change password',
    saving: 'Changing…',
    done: 'Your password has been changed. Your other devices will ask for the new one.',
    mismatch: 'The new passwords do not match.',
    short: 'The new password must be at least 10 characters.',
    wrongCurrent: 'The current password is wrong.',
    offline: 'Changing the password needs a connection.',
    failed: 'Changing the password did not work. Try again in a moment.',
    demo: 'The password cannot be changed in demo mode.',
  },
};

// Messages.login (i18n/area.ts: collected by area-registry.ts)
export const area = defineArea('login', loginFi, loginEn);
declare module '../area' {
  interface AreaMessages extends Record<typeof area.key, typeof loginFi> {}
}
